import { connect } from 'react-redux';
import { selectors } from 'state/selectors';
import { actionCreators } from 'state/actions';
import { mapStateToPropsNDCheckbox, mapDispatchToPropsNDCheckbox } from './connectNDCheckbox';

export const connectNDCheckbox = connect(
  mapStateToPropsNDCheckbox(selectors),
  mapDispatchToPropsNDCheckbox(actionCreators),
);
